import React, { useState, useEffect } from "react";
import { VsiBubble, VsiH4, VsiHr, VsiSpanText } from "../../styled/App.styled";
import { useVsiAppContext } from "../../stores/VsiApp";
import { Col, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { GetAuth, DeleteAuth, PostAuth } from "../../utils/Verbs";
import Grid from "../../components/Grid";
import { Button } from "reactstrap";
import VsiLabeledSelect from "../../components/VsiLabeledSelect";

const parser_types = [
  { value: 0, label: "NOT_APPLICABLE", description: "This parser type is not used." },
  { value: 1, label: "STANDARD", description: "just unzip it." },
  {
    value: 3,
    label: "UNZIP_RENAME",
    description: "unzip file and rename input file, unzip performance file."
  },
  { value: 4, label: "RECURSIVE", description: "unzip subdirectories also (iSilon)" },
  {
    value: 7,
    label: "PERFORMANCE",
    description: "unzip, rename input, and handle performance file"
  },
  { value: 9, label: "BUSINESS_UNIT", description: "process business unit csv file" },
  {
    value: 12,
    label: "PERFORMANCE_LUN_METRICS",
    description: "unzip, rename input, and handle performance file, lun metrics"
  },
  {
    value: 13,
    label: "UNZIP_RUN_PERFORMANCE",
    description: "just unzip it, handle performance file (but don't rename)"
  }
];
const parserControlDef = [

  // {
  //     headerCheckboxSelection: true,
  //     checkboxSelection: true,
  //     width: 10
  // },
  {
    field: "device_type_code",
    flex: 1,
    minWidth: 100,
    headerName: "Device Type Code",
    resizable: true,
    sortable: true
  },
  {
    field: "device_type_description",
    flex: 1,
    minWidth: 100,
    headerName: "Description",
    resizable: true,
    sortable: true
  },
  {
    field: "context",
    flex: 1,
    minWidth: 100,
    headerName: "Context",
    resizable: true,
    sortable: true
  },
  {
    field: "module_name",
    flex: 1,
    minWidth: 100,
    headerName: "Module Name",
    resizable: true,
    sortable: true
  },
  {
    field: "parser_package",
    flex: 1,
    minWidth: 100,
    headerName: "Parser Package",
    resizable: true,
    sortable: true
  },
  {
    field: "parser_method_code",
    flex: 1,
    minWidth: 100,
    headerName: "Parser Method",
    resizable: true,
    sortable: true
  }
];

export default function DevicesParserControl({ title }) {
  const { theme, user, getAccessTokenSilently } = useVsiAppContext();
  const [isLoading, setIsLoading] = useState(true);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState({});
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [parserMethod, setParserMethod] = useState({});
  // updateTrigger is used to force the grid to refresh after you click one of the toggles.
  // The value of updateTrigger is irrelevant.  It is the changing of the value that causes
  // the useEffect hook to run to update the grid data.  Once again, NOTHING depends on the value
  // of updateTrigger.  Its change forces the grid to refresh.
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [showDeviceModal, setShowDeviceModal] = useState(false);

  useEffect(() => {
    const getDeviceTypes = async () => {
      const token = await getAccessTokenSilently();
      GetAuth("/api/v6/admin/device_types", token)
        .then(data => {
          setDeviceTypes(data.data);
          setIsLoading(false);
        })
        .catch(err => {
          console.error(err);
          setIsLoading(false);
        });
    };
    getDeviceTypes();
  }, [updateTrigger]);

  const toggleDeviceModal = () => {
    setShowDeviceModal(!showDeviceModal);
  };
  const updateDeviceHandler = async () => {
    const token = await getAccessTokenSilently();
    PostAuth("/api/v6/admin/device_type", selectedDevice, token)
      .then(data => {
        setUpdateTrigger(!updateTrigger);
        setShowDeviceModal(false);
      })
      .catch(err => {
        console.error(err);
      });

  };
  const addDeviceHandler = () => {
    setSelectedDevice({});
    setShowDeviceModal(true);
  };
  const handleInputChange = (event) => {
    let { name, value } = event.target;
    setSelectedDevice({ ...selectedDevice, [name]: value });
  };
  const handleMethodSelect = (event) => {
    setParserMethod(event);
    setSelectedDevice({
        ...selectedDevice,
        parser_type_id: event.value,
        parser_method_code: event.label,
        parser_method_description: event.description
      }
    );
  };
  const deleteDevice = async () => {
    const token = await getAccessTokenSilently();
    DeleteAuth("/api/v6/admin/device_type/" + selectedDevice.device_type_code, token)
      .then(data => {
        setUpdateTrigger(!updateTrigger);
        setShowWarningModal(false);
        setShowDeviceModal(false);
      })
      .catch(err => {
        console.error(err);
      });
  };
  return (
    <div>
      <VsiH4>{title}</VsiH4>
      <VsiHr />
      {isLoading ? <Spinner color={"primary"} /> : <VsiBubble>
        <Button color="success" onClick={addDeviceHandler}>Add New Device</Button>
        <Grid data={deviceTypes} rowSelection={(device) => setSelectedDevice(device)}
              rowDoubleClicked={(device) => {
                const selectedMethod = parser_types.filter(f => f.value === device.data.parser_type_id);
                setParserMethod(selectedMethod && selectedMethod.length > 0 ? selectedMethod[0] : {});
                setSelectedDevice(device.data);
                setShowDeviceModal(true);
              }}
              columnDefs={parserControlDef}
        />
      </VsiBubble>
      }
      <Modal className="warning-modal" backdrop="static" isOpen={showWarningModal}>
        <ModalHeader toggle={() => setShowWarningModal(false)}>Are you sure you want to delete
          Device {selectedDevice.device_type_code}</ModalHeader>
        <ModalFooter>
          <Button onClick={deleteDevice} color="danger">Confirm Delete</Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" className="file-analysis-modal" backdrop="static" isOpen={showDeviceModal}>
        <ModalHeader className={`bg-${theme}`} toggle={toggleDeviceModal}>
          <VsiSpanText>
            <b>Edit Device Parser Control</b>
          </VsiSpanText>
        </ModalHeader>
        <ModalBody className={`bg-${theme}`}>
          <VsiBubble>
            <Row>
              <Col style={{ marginTop: 0 }} key={`device-type-col`} lg={12} md={12}>
                <Label htmlFor={"device_type_code"}>{"Device Type Code"}</Label>
                <Input type="text" name={"device_type_code"}
                       value={selectedDevice.device_type_code}
                       onChange={handleInputChange} />
              </Col>
            </Row>
            <Row>
              <Col style={{ marginTop: 0 }} key={`device-type-desc-col`} lg={12} md={12}>
                <Label htmlFor={"device_type_description"}>{"Device Type Description"}</Label>
                <Input type="text" name={"device_type_description"}
                       value={selectedDevice.device_type_description}
                       onChange={handleInputChange} />
              </Col>
            </Row>
            <Row>
              <Col style={{ marginTop: 0 }} key={`device-context-col`} lg={12} md={12}>
                <Label htmlFor={"context"}>{"Context"}</Label>
                <Input type="text" name={"context"}
                       value={selectedDevice.context}
                       onChange={handleInputChange} />
              </Col>
            </Row>
            <Row>
              <Col style={{ marginTop: 0 }} key={`parser-name-col`} lg={12} md={12}>
                <Label htmlFor={"module_name"}>{"Parser Name"}</Label>
                <Input type="text" name={"module_name"}
                       value={selectedDevice.module_name}
                       onChange={handleInputChange} />
              </Col>
            </Row>
            <Row>
              <Col style={{ marginTop: 0 }} key={`device-type-col`} lg={12} md={12}>
                <Label htmlFor={"parser_package"}>{"Parser Package"}</Label>
                <Input type="text" name={"parser_package"}
                       value={selectedDevice.parser_package}
                       onChange={handleInputChange} />
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="mt-4 mb-4 d-flex flex-row">
                  <VsiLabeledSelect options={parser_types}
                                    minWidth={300}
                                    isLoading={isLoading}
                                    label={"Parser Method"}
                                    onChange={handleMethodSelect}
                                    defaultValue={parserMethod}
                  />
                  <VsiSpanText>{parserMethod.description}</VsiSpanText>
                </div>
              </Col>
            </Row>

          </VsiBubble>
        </ModalBody>
        <ModalFooter className={`bg-${theme}`}>
          <Button color="success" onClick={updateDeviceHandler}>Save Device</Button>
          <Button color="danger" onClick={() => setShowWarningModal(true)}>Delete Device</Button>
          <Button color="secondary" onClick={toggleDeviceModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
